import { render, staticRenderFns } from "./BaseNotificationsManager.vue?vue&type=template&id=5ce08b2e"
import script from "./BaseNotificationsManager.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseNotificationsManager.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports